import type {
  DatasetInstance,
  DatasetInstanceConfig,
  ModelVersionSelections,
} from '../data-builder.store';
import type { DeliverableColumnConfig } from '../datasets/deliverable-column-config';
import { buildStep2ValidationResult } from '../steps/step2-columns-validation';

type GetReadyInstanceIdsForRowLimitInput = {
  datasetInstances: DatasetInstance[];
  configByInstance: Record<string, DatasetInstanceConfig>;
  deliverablesConfig: Record<string, DeliverableColumnConfig>;
  modelVersions: ModelVersionSelections;
  instanceLabelById: Record<string, string>;
};

export const getReadyInstanceIdsForRowLimit = ({
  datasetInstances,
  configByInstance,
  deliverablesConfig,
  modelVersions,
  instanceLabelById,
}: GetReadyInstanceIdsForRowLimitInput): Set<string> => {
  const issues = buildStep2ValidationResult(
    datasetInstances,
    configByInstance,
    deliverablesConfig,
    modelVersions,
    instanceLabelById
  );
  const instanceIdsWithIssues = new Set(
    issues.map((issue) => issue.instanceId)
  );

  const readyIds = new Set(
    datasetInstances
      .filter((instance) => !instanceIdsWithIssues.has(instance.instanceId))
      .map((instance) => instance.instanceId)
  );
  return readyIds;
};
